import { render, staticRenderFns } from "./CreateQuestionBank.vue?vue&type=template&id=4b4770e3"
import script from "./CreateQuestionBank.vue?vue&type=script&lang=js"
export * from "./CreateQuestionBank.vue?vue&type=script&lang=js"
import style0 from "./CreateQuestionBank.vue?vue&type=style&index=0&id=4b4770e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports